module.exports = __webpack_public_path__ + "img/ixtlahuaca.58c3da9f.jpg";